import { useQuery } from "@tanstack/react-query";
import { axiosInstanceApiNestingale } from "../axios";
async function fetchTrackingStatus(trackingId: string, statusFor: string) {
    const response = await axiosInstanceApiNestingale.get(`/v1/api/rawProductsUploadStatus/${trackingId}/${statusFor}`);
    if (response.status !== 200) throw new Error('Failed to fetch tracking status');
    return response.data; // expected: { status: "pending" | "processing" | "completed" | "failed" }
}

function useGetRawProductsUploadProgress(trackingId?: string, statusFor: string = "UPLOAD") {
    return useQuery({
        queryKey: ['raw-products-tracking-status', trackingId, statusFor],
        queryFn: () => fetchTrackingStatus(trackingId!, statusFor),
        enabled: !!trackingId,
        // Stop polling when status is completed or failed
        refetchInterval: (data: any) => {
            if (!data) return 30000; // keep polling if no data yet
            if (data.percentage === 100 || data.status === 'failed') return false;
            return 30000; // continue polling otherwise
        },
        refetchIntervalInBackground: true,
    });
}
export default useGetRawProductsUploadProgress
